export const addcategorytranslation = {
  cz: {
    title: "Přidat kategorii",
    name: "Název kategorie",
    categorySuccess: "Kategorie byla úspěšně přidána",
    discard: "Zahodit",
    save: "Uložit",
    details: "Detaily",
    subcategories: "Podkategorie",
    thumbnail: "Náhledový obrázek",
    thumbnailSuccess: "Náhledový obrázek byl úspěšně nahrán!",
    thumbnailError: "Nepodařilo se nahrát náhledový obrázek.",
    thumbnailRequired: "Náhledový obrázek je povinný.",
  },
  en: {
    title: "Add Category",
    name: "Category Name",
    categorySuccess: "Category added successfully",
    discard: "Discard",
    save: "Save",
    details: "Details",
    subcategories: "Subcategories",
    thumbnail: "Thumbnail",
    thumbnailSuccess: "Thumbnail uploaded successfully!",
    thumbnailError: "Failed to upload thumbnail.",
    thumbnailRequired: "Thumbnail is required.",
  },
  de: {
    title: "Kategorie hinzufügen",
    name: "Kategoriename",
    categorySuccess: "Kategorie erfolgreich hinzugefügt",
    discard: "Verwerfen",
    save: "Speichern",
    details: "Details",
    subcategories: "Unterkategorien",
    thumbnail: "Miniaturbild",
    thumbnailSuccess: "Miniaturbild erfolgreich hochgeladen!",
    thumbnailError: "Fehler beim Hochladen des Miniaturbilds.",
    thumbnailRequired: "Miniaturbild ist erforderlich.",
  },
  es: {
    title: "Añadir categoría",
    name: "Nombre de la categoría",
    categorySuccess: "Categoría añadida con éxito",
    discard: "Descartar",
    save: "Guardar",
    details: "Detalles",
    subcategories: "Subcategorías",
    thumbnail: "Miniatura",
    thumbnailSuccess: "¡Miniatura subida con éxito!",
    thumbnailError: "Error al subir la miniatura.",
    thumbnailRequired: "La miniatura es obligatoria.",
  },
  fr: {
    title: "Ajouter une catégorie",
    name: "Nom de la catégorie",
    categorySuccess: "Catégorie ajoutée avec succès",
    discard: "Annuler",
    save: "Enregistrer",
    details: "Détails",
    subcategories: "Sous-catégories",
    thumbnail: "Vignette",
    thumbnailSuccess: "Vignette téléchargée avec succès!",
    thumbnailError: "Échec du téléchargement de la vignette.",
    thumbnailRequired: "La vignette est requise.",
  },
  hu: {
    title: "Kategória hozzáadása",
    name: "Kategória neve",
    categorySuccess: "A kategória sikeresen hozzáadva",
    discard: "Elvetés",
    save: "Mentés",
    details: "Részletek",
    subcategories: "Alkategóriák",
    thumbnail: "Bélyegkép",
    thumbnailSuccess: "A bélyegkép sikeresen feltöltve!",
    thumbnailError: "Nem sikerült feltölteni a bélyegképet.",
    thumbnailRequired: "Bélyegkép megadása kötelező.",
  },
  nl: {
    title: "Categorie toevoegen",
    name: "Categorienaam",
    categorySuccess: "Categorie succesvol toegevoegd",
    discard: "Annuleren",
    save: "Opslaan",
    details: "Details",
    subcategories: "Subcategorieën",
    thumbnail: "Miniatuur",
    thumbnailSuccess: "Miniatuur succesvol geüpload!",
    thumbnailError: "Fout bij het uploaden van de miniatuur.",
    thumbnailRequired: "Miniatuur is verplicht.",
  },
  pl: {
    title: "Dodaj kategorię",
    name: "Nazwa kategorii",
    categorySuccess: "Kategoria została pomyślnie dodana",
    discard: "Odrzuć",
    save: "Zapisz",
    details: "Szczegóły",
    subcategories: "Podkategorie",
    thumbnail: "Miniaturka",
    thumbnailSuccess: "Miniaturka została pomyślnie przesłana!",
    thumbnailError: "Nie udało się przesłać miniaturki.",
    thumbnailRequired: "Miniaturka jest wymagana.",
  },
  ru: {
    title: "Добавить категорию",
    name: "Название категории",
    categorySuccess: "Категория успешно добавлена",
    discard: "Отменить",
    save: "Сохранить",
    details: "Детали",
    subcategories: "Подкатегории",
    thumbnail: "Миниатюра",
    thumbnailSuccess: "Миниатюра успешно загружена!",
    thumbnailError: "Не удалось загрузить миниатюру.",
    thumbnailRequired: "Миниатюра обязательна.",
  },
  sk: {
    title: "Pridať kategóriu",
    name: "Názov kategórie",
    categorySuccess: "Kategória bola úspešne pridaná",
    discard: "Zahodiť",
    save: "Uložiť",
    details: "Detaily",
    subcategories: "Podkategórie",
    thumbnail: "Náhľadový obrázok",
    thumbnailSuccess: "Náhľadový obrázok bol úspešne nahraný!",
    thumbnailError: "Nepodarilo sa nahrať náhľadový obrázok.",
    thumbnailRequired: "Náhľadový obrázok je povinný.",
  },
  sv: {
    title: "Lägg till kategori",
    name: "Kategorinamn",
    categorySuccess: "Kategorin lades till framgångsrikt",
    discard: "Kassera",
    save: "Spara",
    details: "Detaljer",
    subcategories: "Underkategorier",
    thumbnail: "Miniatyrbild",
    thumbnailSuccess: "Miniatyrbild uppladdad framgångsrikt!",
    thumbnailError: "Misslyckades med att ladda upp miniatyrbild.",
    thumbnailRequired: "Miniatyrbild krävs.",
  },
  no: {
    title: "Legg til kategori",
    name: "Kategorinavn",
    categorySuccess: "Kategorien ble lagt til",
    discard: "Forkast",
    save: "Lagre",
    details: "Detaljer",
    subcategories: "Underkategorier",
    thumbnail: "Miniatyrbilde",
    thumbnailSuccess: "Miniatyrbilde ble lastet opp!",
    thumbnailError: "Kunne ikke laste opp miniatyrbilde.",
    thumbnailRequired: "Miniatyrbilde er påkrevd.",
  },
  da: {
    title: "Tilføj kategori",
    name: "Kategorinavn",
    categorySuccess: "Kategorien blev tilføjet",
    discard: "Kassér",
    save: "Gem",
    details: "Detaljer",
    subcategories: "Underkategorier",
    thumbnail: "Miniaturebillede",
    thumbnailSuccess: "Miniaturebillede uploadet succesfuldt!",
    thumbnailError: "Fejl ved upload af miniaturebillede.",
    thumbnailRequired: "Miniaturebillede er påkrævet.",
  },
  fi: {
    title: "Lisää kategoria",
    name: "Kategorian nimi",
    categorySuccess: "Kategoria lisättiin onnistuneesti",
    discard: "Hylkää",
    save: "Tallenna",
    details: "Tiedot",
    subcategories: "Alakategoriat",
    thumbnail: "Pienoiskuva",
    thumbnailSuccess: "Pienoiskuva ladattu onnistuneesti!",
    thumbnailError: "Pienoiskuvan lataus epäonnistui.",
    thumbnailRequired: "Pienoiskuva on pakollinen.",
  },
  ar: {
    title: "إضافة فئة",
    name: "اسم الفئة",
    categorySuccess: "تمت إضافة الفئة بنجاح",
    discard: "تجاهل",
    save: "حفظ",
    details: "التفاصيل",
    subcategories: "الفئات الفرعية",
    thumbnail: "صورة مصغرة",
    thumbnailSuccess: "تم تحميل الصورة المصغرة بنجاح!",
    thumbnailError: "فشل تحميل الصورة المصغرة.",
    thumbnailRequired: "الصورة المصغرة مطلوبة.",
  },
};

export default addcategorytranslation;
